import { render, staticRenderFns } from "./wxUser.vue?vue&type=template&id=42360954&scoped=true&"
import script from "./wxUser.vue?vue&type=script&lang=js&"
export * from "./wxUser.vue?vue&type=script&lang=js&"
import style0 from "./wxUser.vue?vue&type=style&index=0&id=42360954&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42360954",
  null
  
)

export default component.exports